<template>
  <v-select
    :value="value"
    @input="onInput"
    v-bind="$attrs"
    v-on="$listeners"
    :items="generationTypes"
    item-value="name"
    :item-text="item => `${item.name} - ${item.description}`"
    clearable
    return-object
  >
    <template v-slot:selection="data"> {{ data.item.name }} - {{ data.item.description }} </template>
  </v-select>
</template>

<script>
import ApiService from "@/gapp-components/services/api.service";

export default {
  name: "CustomReportGenerationTypeField",
  props: {
    value: Object
  },
  data: () => ({
    generationTypes: []
  }),
  methods: {
    onInput(obj) {
      this.$emit("input", obj);
    },
    fetchData() {
      ApiService.get("/api/types/generationType").then(({ data }) => {
        this.generationTypes = data;
      });
    }
  },
  mounted() {
    this.fetchData();
  }
};
</script>
